{
  "hero": {
    "title": "将您的产品目录转变为",
    "subtitle": "AI购物顾问",
    "description": "部署能够销售的会话式销售团队 — 而不仅仅是聊天。在您的网站、社交媒体、WhatsApp和ChatGPT上。",
    "createAssistant": "创建AI助手",
    "bookDemo": "预约演示"
  },
  "nav": {
    "solutions": "解决方案",
    "products": "产品",
    "pricing": "定价",
    "caseStudies": "案例研究",
    "blog": "博客",
    "contact": "联系我们",
    "shoppingExpert": "购物专家",
    "gptStore": "GPT商店"
  },
  "chat": {
    "greeting": "你好！我是您的AI购物助手。尝试询问我关于电视、笔记本电脑或咖啡机等产品的问题。今天我能帮您什么忙？",
    "placeholder": "在这里输入您的消息...",
    "contact": {
      "heading": "请分享您的联系信息"
    }
  },
  "sections": {
    "partners": {
      "title": "受到领先平台的信任"
    },
    "gptPromo": {
      "title": "在GPT商店推出您的品牌",
      "description": "创建一个定制的GPT购物助手，展示您的产品并将浏览者转变为买家。"
    },
    "solutions": {
      "title": "行业解决方案",
      "subtitle": "为您的行业量身定制的AI购物顾问",
      "electronics": {
        "title": "电子产品和科技",
        "description": "帮助客户了解复杂的技术规格并找到完美的设备。",
        "items": [
          "智能产品比较",
          "技术规格匹配",
          "兼容性检查",
          "性能推荐"
        ]
      },
      "fashion": {
        "title": "时尚与服装",
        "description": "提供个性化的穿搭建议和尺寸推荐。",
        "items": [
          "风格匹配和推荐",
          "尺寸和合身指导",
          "季节性趋势建议",
          "服装搭配"
        ]
      },
      "home": {
        "title": "家居与园艺",
        "description": "指导客户进行家居改善和装饰决策。",
        "items": [
          "房间设计咨询",
          "家电推荐",
          "空间优化建议",
          "维护指导"
        ]
      },
      "agency": {
        "title": "代理商和合作伙伴",
        "description": "为服务多个零售客户的代理商提供白标解决方案。",
        "items": [
          "多客户管理",
          "自定义品牌选项",
          "分析和报告",
          "代理商合作伙伴支持"
        ]
      }
    },
    "platforms": {
      "title": "支持的平台"
    },
    "valueProps": {
      "title": "为什么选择Shopilots？",
      "subtitle": "通过真正能够销售的AI转变您的零售体验",
      "conversion": {
        "title": "提升转化率",
        "description": "通过个性化产品推荐和引导式购物体验将浏览者转变为买家。",
        "metric": "转化率"
      },
      "aov": {
        "title": "增加平均订单价值",
        "description": "智能追加销售和交叉销售建议，让客户感到自然和有帮助。",
        "metric": "平均订单价值"
      },
      "returns": {
        "title": "减少退货",
        "description": "更好的产品匹配意味着客户第一次就能获得他们需要的东西。",
        "metric": "退货率"
      },
      "advantage": {
        "title": "Shopilots的优势",
        "description": "与通用聊天机器人不同，我们的AI理解您的产品并以您的品牌声音说话。",
        "features": {
          "catalog": "实时目录集成",
          "sales": "以销售为重点的对话",
          "channels": "多渠道部署",
          "analytics": "收入驱动的分析"
        }
      },
      "testimonial": {
        "title": "客户成功案例",
        "quote": "Shopilots改变了我们的在线销售。客户更快地找到产品，并更自信地购买。",
        "name": "Sarah Johnson",
        "position": "电子商务总监"
      }
    }
  },
  "micro": {
    "demoMode": "演示模式"
  },
  "forms": {
    "name": "姓名",
    "email": "电子邮件",
    "company": "公司",
    "phone": "电话",
    "optional": "可选",
    "thankYou": "谢谢您！"
  },
  "buttons": {
    "sending": "发送中...",
    "submit": "提交",
    "launchAssistant": "启动您的AI助手",
    "callUs": "致电我们",
    "learnMore": "了解更多",
    "getStarted": "开始使用",
    "findSolution": "找到您的解决方案"
  },
  "footer": {
    "description": "能够销售的AI购物顾问 — 而不仅仅是聊天。在您的网站、社交媒体、WhatsApp和ChatGPT上部署。",
    "solutions": "解决方案",
    "resources": "资源",
    "contactUs": "联系我们",
    "copyright": "版权所有。",
    "links": {
      "privacyPolicy": "隐私政策",
      "termsOfService": "服务条款",
      "sitemap": "网站地图"
    }
  }
}